import { Button, Modal } from '@myua/kit';
import { Link21 } from '@myua/icons/dist/bulk16';
import { useDispatch, useSelector } from 'react-redux';
import * as sharingActions from '../actions';
import { useState, useEffect } from 'react';
import { getIsReplacingPack } from '../selectors';

export const EditButton = () => {
  const dispatch = useDispatch();
  const isReplacingPack = useSelector(getIsReplacingPack);
  const [open, setOpen] = useState(false);

  const close = () => {
    if (isReplacingPack) {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    return () => {
      setOpen(false);
    };
  }, []);

  return (
    <>
      <Button className="al-btn-blue-icon" icon={<Link21 />} onClick={() => setOpen(true)}>
        Edit
      </Button>

      <Modal
        className="al-edit-confirm-modal"
        width={460}
        open={open}
        onOk={() => {
          dispatch(sharingActions.editClicked());
        }}
        okButtonProps={{ loading: isReplacingPack }}
        onCancel={close}
        maskClosable
        okText="Continue"
      >
        <div>This shared link will be converted into a pack.</div>
        <div>
          The current files in the <strong>"My Pack"</strong> section will be{' '}
          <strong>replaced</strong>.
        </div>
        <div>Do you want to continue?</div>
      </Modal>
    </>
  );
};
